// Must match --breakpoint-md in global.css — also the breakpoint PromoBanner
// itself uses (`max-md:`) to swap its foreground artwork.
const MOBILE_MEDIA_QUERY = "(max-width: 767px)";

export default MOBILE_MEDIA_QUERY;
